resize();

function resize(){
  const ad = $('.adverts-sidebar');
  if ( $(window).height() < 768 && ad.height() > 600) {
    ad.addClass('small-screen');
  } else {
    ad.removeClass('small-screen');
  }
}

$(window).on("load scroll resize",function(e){ resize(); });
